import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    faqs: {
        search_results: [] as any[],
        page: undefined,
    } as any,
    auto: [],
    loading: false
};

const faqSlice = createSlice({
    name: 'faq',
    initialState,
    reducers: {
        setLoading: (state: any) => {
            state.loading = true
            state.faqs = {
                search_results: [],
                page: undefined,
            };
            state.auto = [];
        },
        setFAQsAutoComplete: (state: any, action) => {
            state.auto = action.payload;
            state.loading = false
            state.faqs = {
                search_results: [],
                page: undefined,
            };
        },
        getFAQsAutoComplete: (state: any, action) => {},
        setFAQByEnhancementId: (state: any, action) => {
            state.faqs = action.payload;
        },
        getFAQsByEnhancementId : (state: any, action) => {},
        setFAQs: (state: any, action) => {
            if (state.faqs?.search_results.length > 0 && action.payload.page !== state.faqs.page && !action.payload.error) {
            const search_results = [...state.faqs.search_results, ...action.payload.search_results];
            state.faqs = {
                ...action.payload,
                search_results,
            };
            } else {
            delete action.payload.error;
            state.faqs = action.payload;
            }
            state.auto = [];
            state.loading = false
        },
        getFAQs: (state, action) => {},
    },
});

export const { getFAQsAutoComplete, setFAQsAutoComplete, setFAQByEnhancementId, getFAQsByEnhancementId , getFAQs, setFAQs, setLoading } = faqSlice.actions;

export default faqSlice.reducer;